<template>

</template>

<script>
export default {
  name: "FormStep",
  props: [
    'measurement',
  ],

  data() {

    return {
      localMeasurement: this.measurement,

      fieldRequirements: {},
    };
  },

  computed: {
    fieldsComplete(){
      return this.failedFields.length == 0;
    },
    failedFields(){

			let allFieldRequirements = {};
			if(this.fieldRequirements){
				allFieldRequirements = {...allFieldRequirements, ...this.fieldRequirements};
			}
			if(this.dynamicFieldRequirements){
				allFieldRequirements = {...allFieldRequirements, ...this.dynamicFieldRequirements};
			}
      return [...Object.keys(allFieldRequirements)].map((field) => {
        if(!this.testRequirements(this.localMeasurement[field], allFieldRequirements[field])){
          return field;
        }
        return null;
      }).filter(x=>x);
    },
		dynamicFieldRequirements(){
			return {};
		}
  },
  methods: {
    testRequirements(value, requirements){
      const failed = [...requirements].map((requirement) => {
        switch(requirement){
          case 'required':
            if(value || value === 0){
              return null;
            }
            break;
        }
        return requirement;
      }).filter(x=>x);


      return failed.length == 0;
    },

    save(){
      this.$emit('update', this.localMeasurement);
    }
  },

}
</script>

<style scoped>

</style>
